module.exports = __webpack_public_path__ + "static/media/cusd3.c951841f.jpg";